(function() {
  'use strict';
  angular.module('benefits')
  .component('memberInfo', {
    bindings: {
      refId: '='
    },
    controller: ['benefitService', 'historyService', '$rootScope',function memberInfoController(benefitService, historyService, $rootScope) {
      var ctrl = this;
      this.$onInit = function() {
        benefitService.getMemberByRefId(ctrl.refId).then(function(data) {
          ctrl.model  = data;

        });
        benefitService.getPolicyByRefId(ctrl.refId).then((p) => {
          ctrl.policy = p;
        });
        benefitService.planSummaryPromise.then(function(data) {
          ctrl.plan = data;
          //if call to teledent fails just get the history again
          if(!ctrl.plan.firstName) {
            $rootScope.$broadcast("lookUpHistory", true);
          } else {
            var index = _.findIndex(historyService.benefitHistories, function(history) {
              return history.eventData.subscriberId == ctrl.plan.subscriberId &&
                history.eventData.birthDate === ctrl.plan.dateOfBirth &&
                history.eventData.name == ctrl.plan.firstName + " " + ctrl.plan.lastName;
            });
            if(index >= 0) {
              historyService.benefitHistories.splice(index, 1);
            }
            historyService.benefitHistories.splice(0,0,{eventData:{
              name:ctrl.plan.firstName + " " + ctrl.plan.lastName,
              refId: ctrl.plan.referenceId,
              subscriberId: ctrl.plan.subscriberId,
              birthDate: ctrl.plan.dateOfBirth,
              eventName: "Lookup Eligibility"}});
            if(historyService.benefitHistories.length > historyService.maxSize) {
              historyService.benefitHistories.splice(historyService.maxSize,1);
            }
          }
        });
      };
    }],
    templateUrl: 'js/benefits/memberInfo.html' + appVersion
  });
})();
